import React from "react";
import type { LinkProps } from "../Link";
import LinkMemo from "../Link";
import { styled } from "@linaria/react";
import { color } from "..";

export enum LinkType {
  INTERNAL_LINK = "INTERNAL_NAVIGATION",
  EXTERNAL_LINK = "EXTERNAL_LINK",
}

type TooltipLinkProps = LinkProps & {
  linkValue: string;
  linkLabel: string;
  linkType: LinkType;
};

const TooltipLink = ({ linkValue, linkLabel, linkType, ...linkProps }: TooltipLinkProps) => {
  const link = LinkType.EXTERNAL_LINK ? { href: linkValue } : { to: linkValue };
  return (
    <LinkMemo {...linkProps} {...link}>
      {linkLabel}
    </LinkMemo>
  );
};

const StyledTooltipLink = styled(TooltipLink)`
  display: inline;
  color: ${color.lightNitrogen500_Main};
  text-decoration: underline;
`;

export default React.memo(StyledTooltipLink);
